export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export function isDefinedAndIsNotNaN(value: NotDefined<number>): value is number {
  return isDefined(value) && !Number.isNaN(value);
}

export function replaceEmptyArray<T>(value: T[]): T[] | undefined {
  if (Array.isArray(value) && value.length > 0) {
    return value;
  }

  return undefined;
}

export function isArrayEquals(a?: (string | number)[], b?: (string | number)[]) {
  return Array.isArray(a) && Array.isArray(b)
    && a.length === b.length
    && a.every((val, index) => val === b[index]);
}

export function isNumber(str: string | number | undefined | null) {
  return !(Number.isNaN(Number(str)));
}

// https://gist.github.com/znechai/1b25d0ee9a92e5b879175ab4f040dbbc
export function pluralize(count: number, words: string[]): string {
  const cases = [
    2,
    0,
    1,
    1,
    1,
    2,
  ];

  return words[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)]];
}

export function genSPALink(link?: string) {
  const regex = /https:\/\/(\w+).oskelly.tech/g;

  return link
    ?.replace('https://oskelly.ru', '')
    ?.replace('http://localhost:8080', '')
    ?.replace(regex, '');
}

export function formatPrice(price: number) {
  return price?.toLocaleString('ru-RU');
}
